module.exports = __webpack_public_path__ + "img/901277275.472edcc2.png";